/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnDownLeft: {
  name: 'arrow-turn-down-left';
  data: string;
} = {
  name: 'arrow-turn-down-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 6a1 1 0 0 1 1 1V12a2 2 0 0 1-2 2H8.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L8.414 12H18V7a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
